import * as React from "react";
import CheckBox from "../DataDisplay/CheckBoxComponent";
import { IContentSummary, IStep } from "./StepGuideComponent";
import i18n from "../../i18n/i18n";
import IApplicationForTaxReplacementVm from "../../models/citizen/IApplicationForTaxReplacementVm";
import IApplicationForTaxVm from "../../models/shared/IApplicationForTaxVm";

interface SummaryComponentProps {
  stepsCompleted: IStep[];
  application?: IApplicationForTaxReplacementVm;
  declarationOfLossChecked: boolean;
  setDeclarationOfLossChecked: (checked: boolean) => void;
}

const SummaryComponent: React.FC<SummaryComponentProps> = ({ stepsCompleted, declarationOfLossChecked, setDeclarationOfLossChecked, application }) => {
  const renderStepContent = (step: IStep) => (
    <div style={{ marginBottom: "22px" }} key={step.id}>
      <hr />
      <h3>{step.title}</h3>
      <div className="row-fluid" style={{ marginLeft: "0px" }}>
        <dl className="list no-content clearfix">
          {step.contentSummary?.map((contentSummary: IContentSummary) => (
            <React.Fragment key={contentSummary.key}>
              <dt>
                <div style={{ paddingRight: "20%" }}>{i18n.t(contentSummary.key)}:</div>
              </dt>
              <dd>{contentSummary.value}</dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </div>
  );

  const renderFinalStep = () => {
    if (!application) return null;
    const oldCertificateNumber = "previousApplicationForTax" in application ? (application as IApplicationForTaxVm) : undefined;
    return (
      <div>
        <hr />
        <h3 dangerouslySetInnerHTML={{ __html: i18n.t("TEXT_DECLARATION_OF_LOSS_HEADER") }}></h3>
        <p>
          Når du indsender din ansøgning bekræfter du på tro og love, at du har mistet dit chaufførkort med nummer {oldCertificateNumber ? oldCertificateNumber.previousApplicationForTax.certificateNumber : "Ukendt"}. Når du trykker ”indsend” tilbagekaldes dit tidligere chaufførkort i Færdselsstyrelsens systemer, og kortet er ikke længere gyldigt. Du skal indgive betaling via det betalingslink, du får tilsendt til din digitale postkasse, når du har indsendt ansøgningen. Herefter bestilles det nye
          kort til dig. Hvis du genfinder dit chaufførkort på et senere tidspunkt, skal det destrueres, da det ikke længere er gyldigt, og ikke længere kan anvendes til erhvervsmæssig persontransport.
        </p>
        <CheckBox checked={declarationOfLossChecked} label={i18n.t("TEXT_DECLARATION_OF_LOSS")} readonly={false} uiTestAttribute="checkbox-declaration-of-loss" onChange={() => setDeclarationOfLossChecked(!declarationOfLossChecked)} />
      </div>
    );
  };

  const createSummaryContent = () => {
    const summarySteps = stepsCompleted.map(renderStepContent);
    return application ? [...summarySteps, renderFinalStep()] : summarySteps;
  };

  return <>{createSummaryContent()}</>;
};

export default SummaryComponent;
